import { FC } from 'react';
import { Tag } from '@brg/api';
import { CreateTagComponent } from './CreateTagComponent';
import { CreatePersonalizedTagComponent } from './CreatePersonalizedTagComponent';

export interface ICreateTagModalProps {
  onCreateTag?: (value?: any) => void;
  onClose: () => void;
  isModal?: boolean;
  isEducation?: boolean;
  isPersonalized?: boolean;
  editTag?: Tag<'Global'>;
  onUpdateTag?: (value?: any) => void;
}

export const CreateTagModal: FC<ICreateTagModalProps> = (props) => {
  const { isPersonalized, ...rest } = props;

  if (isPersonalized) {
    return <CreatePersonalizedTagComponent {...props} />;
  }

  return <CreateTagComponent {...rest} />;
};
import { FC } from 'react';
import { Tag } from '@brg/api';
import { CreateTagComponent } from './CreateTagComponent';
import { CreatePersonalizedTagComponent } from './CreatePersonalizedTagComponent';

export interface ICreateTagModalProps {
  onCreateTag?: (value?: any) => void;
  onClose: () => void;
  isModal?: boolean;
  isEducation?: boolean;
  isPersonalized?: boolean;
  editTag?: Tag<'Global'>;
  onUpdateTag?: (value?: any) => void;
}

export const CreateTagModal: FC<ICreateTagModalProps> = (props) => {
  const { isPersonalized, ...rest } = props;

  if (isPersonalized) {
    return <CreatePersonalizedTagComponent {...props} />;
  }

  return <CreateTagComponent {...rest} />;
};
